import Seo from '../../../components/common/Seo'
import Sidebar from '../../../components/rsldashboard/common/Sidebar';
import Header from '../../../components/header/header-rslhome'
import SettingsTabs from '../../../components/rsldashboard/db-settings/components/index';
import Footer from '../../../components/rsldashboard/common/Footer';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import PersonalInfo from "../../../components/rsldashboard/db-settings/components/PersonalInfo";
import { fetchSeoByPage } from '../../../lib/seoHelper'

const index = ({ meta }) => {
  return (
    <>
      <Seo meta={meta} />
      {/* End Page Title */}

      <div className='header-margin'></div>

      <Header bgColor="#f6f6f6" />
      {/* End dashboard-header */}

      <div className='dashboard'>
        <div className='dashboard__sidebar bg-white scroll-bar-1'>
          <Sidebar />
          {/* End sidebar */}
        </div>
        {/* End dashboard__sidebar */}

        <div
          className='offcanvas offcanvas-start'
          tabIndex='-1'
          id='carSidebar'
        >
          <div className='offcanvas-header'>
            <h5 className='offcanvas-title' id='offcanvasLabel'>
              Settings
            </h5>

            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='offcanvas'
              aria-label='Close'
            ></button>
          </div>
          {/* End offcanvas header */}

          <div className='offcanvas-body'>
            <aside className='sidebar y-gap-40  xl:d-block' style={{ marginTop: "10px" }}>
              <Sidebar enableClos={true} />
            </aside>
          </div>
          {/* End offcanvas body */}
        </div>

        <div className='dashboard__main'>
          {/* <div className='dashboard__content bg-light-4'> */}
          <div className='dashboard__content tab-header'>
            <div className='row y-gap-20 justify-between items-center'>
              <div className='col-auto col-md-8'>
                <div className='d-flex items-center justify-between'>
                  <h1 className='text-30 lh-14 fw-600'>Account settings</h1>
                  <ManageAccountsIcon
                    data-bs-toggle='offcanvas'
                    data-bs-target='#carSidebar'
                    className='d-lg-none text-secondary'
                  />
                </div>
                <div className='text-15 text-light-1'>
                  Manage your personal information, manage security settings,
                  and customize your experience.
                  {/* Manage your RSL Lifestyle experience */}
                </div>
              </div>

              {/* End .col-12 */}
            </div>
            {/* End .row */}

            <div className='pt-30 pb-10'>
              {/* <SettingsTabs /> */}
              {/* <PersonalInfo userDetail={userDetail} /> */}
              <PersonalInfo />
            </div>

            {/* <Footer /> */}
          </div>
          {/* End .dashboard__content */}
        </div>
        {/* End dashbaord content */}
      </div>
      {/* End dashbaord content */}
    </>
  )
}

export default index;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}